import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import style from './SavePreloader.module.scss';

import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

export const SavePreloader = observer(() => {
    const [enableAnimation, setEnableAnimation] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => setEnableAnimation(true), 5000);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div
            className={classnames([
                style.root,
                enableAnimation && style.enableAnimation,
                store.app.isOnSave ? style.show : style.hide,
            ])}
        >
            <div className={style.title}>{translate('changesSaved')}</div>
            <div className={style.savePreloader} />
        </div>
    );
});
